import CryptoJS from "crypto-js";
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };

const decryptData = (encryptedData) => {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        console.log(error.message || 'An error occurred. Please try again.');
        return null;
    }
};
  
export function saveToCache(key, data){
    localStorage.setItem(key, encryptData((data)));
};

export function getFromCache(key) {
    var data = localStorage.getItem(key);
    return data != null ? decryptData(data) : null;
}

export function removeFromCache(key) {

    return localStorage.removeItem(key);
}

export default function BullCache(){ };
